// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LikedList_container__QDH6i {
    width: 90%;
    margin: auto;
    max-width: 1200px;
    padding-top: 7rem;
  }
  
  .LikedList_title__452\\+w {
    text-align: center;
    font-size: 45px;
    margin-bottom: 60px;
    color: #fff;
  }
  
  .LikedList_typeSection__kpOxh {
    margin-bottom: 30px;
  }
  
  .LikedList_typeTitle__qG2qL {
    font-size: 25px;
    text-align: left;
    margin-bottom: 20px;
    color: #fff;
  }
  
  .LikedList_grid__09AJa {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content:flex-start;
  }
  
  .LikedList_card__Ckjzg {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
  }
  
  /* Image Styles */
  .LikedList_cardImage__xu\\+RA {
    width: 100%;
    object-fit: cover;
    display: block;
  }
  
  /* Different image heights for categories */
  .LikedList_ebook__PfpYK {
    /* width: 215px;
    height: 270px; */
    object-fit: contain;
  }
  
  .LikedList_audio__kvWlf {
    /* width: 215px;
    height: 270px; */
    object-fit: contain;
  }
  
  .LikedList_video__ZC4gj {
    /* width: 215px;
    height: 270px; */
    object-fit: contain;
  }
  
  .LikedList_shorts__MmiKQ {
    /* width: 200px;
    height: 320px; */
    object-fit: contain;
  }
  
  /* Play Button Overlay */
  .LikedList_playButton__pWstz {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #E50914;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
  
  /* Remove (Cut) Button */
  .LikedList_removeButton__D9gjB {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 0, 0, 0.8);
    border: none;
    color: white;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 14px;
    cursor: pointer;
  }
  
  .LikedList_removeButton__D9gjB:hover {
    background: red;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .LikedList_title__452\\+w {
      font-size: 35px;
    }
  
    .LikedList_typeTitle__qG2qL {
      font-size: 20px;
    }
  
    .LikedList_grid__09AJa {
      gap: 5px;
    }
  
  }
  
  @media (max-width: 480px) {
    .LikedList_title__452\\+w {
      font-size: 28px;
    }
    .LikedList_playButton__pWstz {
      width: 30px;
      height: 30px;
      font-size: 16px;
    }
  
    .LikedList_typeTitle__qG2qL {
      font-size: 18px;
    }
     
    .LikedList_cardImage__xu\\+RA {
      max-height: 129px;
    }
  
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/settings-pages/LikedList.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;;EAEA,2CAA2C;EAC3C;IACE;oBACgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;oBACgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;oBACgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;oBACgB;IAChB,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,QAAQ;IACV;;EAEF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;EAEF","sourcesContent":[".container {\n    width: 90%;\n    margin: auto;\n    max-width: 1200px;\n    padding-top: 7rem;\n  }\n  \n  .title {\n    text-align: center;\n    font-size: 45px;\n    margin-bottom: 60px;\n    color: #fff;\n  }\n  \n  .typeSection {\n    margin-bottom: 30px;\n  }\n  \n  .typeTitle {\n    font-size: 25px;\n    text-align: left;\n    margin-bottom: 20px;\n    color: #fff;\n  }\n  \n  .grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content:flex-start;\n  }\n  \n  .card {\n    position: relative;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  /* Image Styles */\n  .cardImage {\n    width: 100%;\n    object-fit: cover;\n    display: block;\n  }\n  \n  /* Different image heights for categories */\n  .ebook {\n    /* width: 215px;\n    height: 270px; */\n    object-fit: contain;\n  }\n  \n  .audio {\n    /* width: 215px;\n    height: 270px; */\n    object-fit: contain;\n  }\n  \n  .video {\n    /* width: 215px;\n    height: 270px; */\n    object-fit: contain;\n  }\n  \n  .shorts {\n    /* width: 200px;\n    height: 320px; */\n    object-fit: contain;\n  }\n  \n  /* Play Button Overlay */\n  .playButton {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #E50914;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  \n  /* Remove (Cut) Button */\n  .removeButton {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(255, 0, 0, 0.8);\n    border: none;\n    color: white;\n    width: 25px;\n    height: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  \n  .removeButton:hover {\n    background: red;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .title {\n      font-size: 35px;\n    }\n  \n    .typeTitle {\n      font-size: 20px;\n    }\n  \n    .grid {\n      gap: 5px;\n    }\n  \n  }\n  \n  @media (max-width: 480px) {\n    .title {\n      font-size: 28px;\n    }\n    .playButton {\n      width: 30px;\n      height: 30px;\n      font-size: 16px;\n    }\n  \n    .typeTitle {\n      font-size: 18px;\n    }\n     \n    .cardImage {\n      max-height: 129px;\n    }\n  \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LikedList_container__QDH6i`,
	"title": `LikedList_title__452+w`,
	"typeSection": `LikedList_typeSection__kpOxh`,
	"typeTitle": `LikedList_typeTitle__qG2qL`,
	"grid": `LikedList_grid__09AJa`,
	"card": `LikedList_card__Ckjzg`,
	"cardImage": `LikedList_cardImage__xu+RA`,
	"ebook": `LikedList_ebook__PfpYK`,
	"audio": `LikedList_audio__kvWlf`,
	"video": `LikedList_video__ZC4gj`,
	"shorts": `LikedList_shorts__MmiKQ`,
	"playButton": `LikedList_playButton__pWstz`,
	"removeButton": `LikedList_removeButton__D9gjB`
};
export default ___CSS_LOADER_EXPORT___;
